import React from 'react';
export function BeforeAfterOutdoor() {
  return <section className="bg-warm-light py-16 md:py-20 px-4" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        {/* Section label */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm text-center mb-3" data-id="element-46">
          From random snapshots to photos worth keeping
        </p>

        {/* Before / After Image Comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-47">
          {/* Before */}
          <div className="relative rounded-2xl overflow-hidden shadow-lg" data-id="element-48">
            <img src="https://cdn.magicpatterns.com/uploads/rNKQs9brcadP3NAHK3gciA/ChatGPT_Image_Mar_20,_2026,_05_25_18_PM.png" alt="Before: Golden retriever outdoors with basic composition and casual framing" className="w-full h-64 md:h-80 object-cover" data-id="element-49" />
            <div className="absolute top-3 left-3 bg-red-500/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-50">
              Before
            </div>
          </div>

          {/* After */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl ring-2 ring-soft-gold/30" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/59RPMESyxwcHuqwmaDkrZQ/ChatGPT_Image_Mar_20,_2026,_05_25_14_PM.png" alt="After: Golden retriever outdoors with warm golden hour lighting and polished composition" className="w-full h-64 md:h-80 object-cover" data-id="element-52" />
            <div className="absolute top-3 left-3 bg-green-600/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-53">
              After
            </div>
          </div>
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-54">
          A few simple changes can turn an ordinary outdoor photo into something{' '}
          <span className="font-semibold text-warm-hero" data-id="element-55">
            beautiful, intentional, and frame-worthy.
          </span>
        </p>
      </div>
    </section>;
}